import { capitalizeFirstLetter as B } from "./index.es169.js";
import { simpleClone as C, isNumber as D } from "./index.es170.js";
import { createStatisticsSettings as E, unitLabels as b, makeHash as L } from "./index.es82.js";
const h = (n) => {
  const { name: e, fields: i } = n, s = {
    name: e,
    fields: n.fields?.map((t) => t.name) || []
  };
  return i?.length && "childDimension" in i[0] ? [s, ...h(i[0].childDimension)] : [s];
}, x = (n, e, i) => {
  if (e && e.length) {
    const s = e[0], t = n.fields.find((a) => a.name === s);
    t && (e.length === 1 && "value" in t && (t.value = i), e.length > 1 && "childDimension" in t && x(t.childDimension, e.slice(1), i));
  }
}, v = (n, e) => {
  if (e.length) {
    const i = n.fields.find((s) => s.name === e[0]);
    if (i) {
      if (e.length === 1 && "value" in i)
        return i.value;
      if (e.length > 1) {
        const s = e.slice(1);
        if ("childDimension" in i)
          return v(i.childDimension, s);
      }
    }
  }
  return null;
}, I = (n) => {
  if (n && n.length) {
    let e;
    if (n.length === 1)
      e = n[0].fields.map((i) => ({ name: i, value: null }));
    else {
      const i = n.slice(1);
      e = n[0].fields.map((s) => ({
        name: s,
        childDimension: I(i)
      }));
    }
    return {
      name: n[0].name,
      fields: e
    };
  } else
    throw "createDimensionFromDimensionInfo called without dimensionInfo";
}, T = (n) => {
  if (n && n.length) {
    if (n.length === 1)
      return n[0].fields.map((e) => [e]);
    {
      const e = [...n], i = e.shift(), s = T(e);
      if (i?.fields)
        return i.fields.flatMap(
          (t) => s.map((a) => [t, ...a])
        );
    }
  }
  return [];
}, p = (n, e) => {
  const i = h(n), s = i.findIndex(
    (t) => t.name === e
  );
  if (s > 0) {
    const t = [...i];
    t.splice(s, 1);
    const a = i[s], r = I([
      a,
      ...t
    ]);
    return T(i).forEach((l) => {
      const m = [
        l[s],
        ...l.slice(0, s),
        ...l.slice(s + 1)
      ], c = v(n, l);
      x(r, m, c);
    }), r;
  }
  return n;
}, g = (n) => "value" in n ? n?.value ?? ".." : n.childDimension.fields.reduce((e, i) => {
  const s = g(i), t = D(e), a = D(s);
  return t && a ? e + s : !t && a ? s : "..";
}, 0), y = (n) => {
  if ("value" in n)
    return n.value;
  const e = n.childDimension.fields.map((i) => y(i)).filter((i) => typeof i == "number");
  return e.length ? e.reduce((i, s) => i + (s || 0), 0) / e.length : null;
}, U = (n) => {
  const { name: e, fields: i } = n;
  return {
    name: e,
    fields: i?.map((s) => ({ name: s.name, value: g(s) }))
  };
}, k = (n) => {
  const { name: e, fields: i } = n;
  return {
    name: e,
    fields: i?.map((s) => ({ name: s.name, value: y(s) }))
  };
}, N = (n) => {
  const { name: e, fields: i } = n;
  return {
    name: e,
    fields: i?.map((s) => "childDimension" in s ? {
      name: s.name,
      childDimension: U(s.childDimension)
    } : s)
  };
}, O = (n) => {
  const { name: e, fields: i } = n;
  return {
    name: e,
    fields: i?.map((s) => "childDimension" in s ? {
      name: s.name,
      childDimension: k(s.childDimension)
    } : s)
  };
}, G = (n, e) => {
  const i = h(n), { units: s } = e;
  return typeof s == "object" ? i.find(
    (t) => t.name === s.name
  ) ? p(n, s.name).fields.reduce((t, a) => {
    const r = s.fieldUnits[a.name], l = n.fields.find(
      (m) => m.name === a.name
    );
    return r && l && "childDimension" in l ? { ...t, [r]: l.childDimension } : t;
  }, {}) : { Amount: n } : { [s]: n };
}, H = (n, e) => {
  if (typeof e.units == "string")
    return e.units;
  const i = e.units, s = i.fieldUnits, t = n[i.name];
  return t && s[t] || "Amount";
}, u = (n, e, i) => {
  const s = Array.isArray(i) ? i : [i];
  return n.name === e ? {
    name: n.name,
    fields: n.fields.filter((t) => s.includes(t.name))
  } : {
    name: n.name,
    fields: n.fields.map((t) => "childDimension" in t ? {
      name: t.name,
      childDimension: u(
        t.childDimension,
        e,
        s
      )
    } : t)
  };
}, J = (n, e) => {
  let i = C(n);
  const s = h(i), t = s.map((a) => a.name);
  e.secondary && t.includes(e.secondary) && (i = p(i, e.secondary)), e.primary && t.includes(e.primary) && (i = p(i, e.primary));
  for (const a in e.filters) {
    const r = e.filters[a], l = s.find(
      (m) => m.name === a
    );
    l && l.fields.includes(r) && (i = u(
      i,
      a,
      r
    ));
  }
  return e.primary && e.primaryFilter?.length && (i = u(
    i,
    e.primary,
    e.primaryFilter
  )), e.secondary && e.secondaryFilter?.length && (i = u(
    i,
    e.secondary,
    e.secondaryFilter
  )), i;
}, K = (n, e, i, s) => {
  let t;
  const a = e ? g : y;
  e ? i ? t = U : t = N : i ? t = k : t = O;
  const r = t(n);
  if (i)
    return {
      datasets: [
        {
          data: r.fields?.map((l) => a(l)),
          label: s || "",
          name: r.name
        }
      ],
      labels: r.fields?.map((l) => l.name),
      names: r.fields?.map((l) => l.name)
    };
  {
    const l = {
      datasets: [],
      labels: [],
      names: []
    };
    for (let m = 0; m < r.fields.length; m++) {
      const c = r.fields[m];
      if (l.labels[m] = c.name, l.names[m] = c.name, "childDimension" in c) {
        m === 0 && (l.datasets = c.childDimension.fields.map((o) => ({
          data: [],
          label: o.name,
          name: o.name
        })));
        for (let o = 0; o < c.childDimension.fields.length; o++) {
          const d = c.childDimension.fields[o];
          if (l.datasets[o]) {
            const f = l.datasets[o].data;
            f[m] = a(d);
          }
        }
      }
    }
    return l;
  }
}, V = (n, e) => [...n, ...Array.isArray(e.data) ? e.data : []], P = (n) => n.reduce(V, []), Y = (n) => P(n).reduce(
  (e, i) => typeof i == "number" && typeof e == "number" && i < e ? i : e,
  Number.MAX_VALUE
), j = (n, e) => {
  if (Array.isArray(n)) {
    const i = Y(n);
    if (typeof i == "number" && typeof e == "number" && e >= 0 && e < 100)
      return i * e / 100;
  }
}, F = (n, e, i, s, t) => {
  if (t === "y")
    return n[e] || B(e);
  const a = s?.units;
  if (a) {
    if (typeof a == "string")
      return s.labels?.[a] || b[a];
    {
      const r = i[a.name];
      if (r && a.fieldUnits?.[r]) {
        const l = a.fieldUnits[r];
        return s.labels?.[l] || b[l];
      }
    }
  }
  return "";
}, A = (n) => {
  const { xTitle: e, yTitle: i } = n;
  n.xTitle = i, n.yTitle = e;
}, Q = (n, e, i, s, t) => {
  const a = { ...n.screen }, r = { ...n.download }, l = j(
    s.datasets,
    e.minYPercent
  );
  a.suggestedMin = l, r.suggestedMin = l, t.length && (a.annotations = t, r.annotations = t), i === "bar" && e.horizontalBar && (A(a), A(r), a.indexAxis = "y", r.indexAxis = "y");
  const { blockId: m } = a;
  return m && (a.legendElementId = z(
    m,
    i === "line" ? "line" : "bar"
  )), { screen: a, download: r };
}, R = (n, e, i, s, t, a, r, l) => {
  const m = i?.overrideMaxY[n], c = F(
    t,
    a,
    r,
    l,
    "x"
  ), o = F(
    t,
    a,
    r,
    l,
    "y"
  ), d = {
    currentUnits: n,
    isStacked: !!i.isStacked,
    yMax: m,
    xTicksMax: 30,
    yTitle: c,
    xTitle: o,
    blockId: s
  }, f = {
    currentUnits: n
  }, $ = {
    currentUnits: n,
    title: e,
    chartBackgroundColor: "#F6F6F3"
  }, M = {
    ...d,
    ...f
  }, w = {
    ...d,
    ...$
  };
  return {
    screen: M,
    download: w
  };
}, z = (n, e) => `legend-element-${n}-${e}`, S = (n, e) => {
  const { primary: i, secondary: s, filters: t } = n;
  return `bufdir-statistikk-${L(
    `${JSON.stringify(t)}-${i}-${s}${e}`
  )}`;
}, W = (n, e) => `${S(n, e)}.png`, q = (n, e) => `${S(n, e)}.xlsx`, ee = (n, e, i) => {
  if (typeof n.units != "string") {
    const s = n.units, { fieldUnits: t } = s, a = Object.keys(t).map((r) => ({ name: r, units: t[r] })).find((r) => r.units === e);
    if (a)
      return a.name;
  }
  return i;
}, ne = (n, e, i) => {
  const s = i.map((o) => o.name), t = E(
    n,
    e,
    s
  ), { filters: a, primaryFilter: r, secondaryFilter: l, primary: m, secondary: c } = t;
  for (const o in a) {
    const d = i.find((f) => f.name === o);
    d && d.fields.includes(a[o]) || (a[o] = "");
  }
  if (m && r && r.length) {
    const o = i.find((d) => d.name === m);
    o && (t.primaryFilter = r.filter(
      (d) => o.fields.includes(d)
    ));
  }
  if (c && l && l.length) {
    const o = i.find((d) => d.name === c);
    o && (t.secondaryFilter = l.filter(
      (d) => o.fields.includes(d)
    ));
  }
  return t;
};
export {
  j as calculateSuggestedYMin,
  R as createChartOptionVariablesByType,
  J as createDimensionForSettings,
  I as createDimensionFromDimensionInfo,
  K as dimensionToChartData,
  y as fieldAverage,
  g as fieldTotal,
  u as filterDimension,
  W as getChartFileNameFromSettingsAndBlockId,
  h as getDimensionInfo,
  v as getDimensionPathValue,
  q as getExcelFileNameFromSettingsAndBlockId,
  ee as getImplicitSecondaryLabel,
  z as getLegendElementId,
  T as getPathsForDimensionInfo,
  ne as getStatisticsSettings,
  H as getUnitsFromFiltersAndUnitOptions,
  p as promoteDimension,
  x as setDimensionPathValue,
  k as singleDimensionAverages,
  U as singleDimensionTotals,
  G as toUnitDimensionMap,
  O as twoDimensionAverages,
  N as twoDimensionTotals,
  Q as updateChartOptionVariablesByType
};
//# sourceMappingURL=index.es97.js.map
